import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import Notfication from '../../../utils/notification-helper';
import mobx, { observable, action } from 'mobx';
import {
    Row,
    Col,
    Nav,
    Table,
    FormControl,
    FormGroup,
    ControlLabel,
    Content,
    Checkbox,
    Button,
    OverlayTrigger,
    Tooltip,
} from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import WorkflowStepBaseComponent from '../workflow-step-base';
import moment from 'moment';
import TimelineWorkflowStepLineitem from './timeline-workflow-step-lineitem';
import TimelineRenderHelper from './timeline-render-helper';
import GoogleAPIResource from '../../../resources/google-api-resource';
import appConfig from 'react-global-configuration';
import _ from 'lodash';
import DndContainer from './dnd-container';
import StepActionButtons from '../components/step-actions';
import StepHistory from '../../../components/step-history';
import Cons from '../../../../isomorphic/cons';
import WorkflowStepTransitionModel from '../../workflow-step-transition-model';
import DeadlineCalculatedHelper from '../../../utils/deadline-calculated-helper';

@inject('appStore')
@observer
export default class TimelineWorkflowStep extends WorkflowStepBaseComponent {
    constructor(props) {
        super(props);
        this.googleAPIResource = new GoogleAPIResource();
    }

    handleSend() {
        appStore.workflowStore.setLoading(true);
        const step = this.props.step;
        step.state.isComplete = true;
        step.state.data.message = `Calendar Timeline Created: ${new moment().format('llll')}.`;
        step.state.data.timelineGeneratedOn = new moment().format();
        step.state.data.timeline = mobx.toJS(
            appStore.workflowStore.timelineWorkflowStore.timelineEventInstancesCalculated
        );
        step.state.data.contractAcceptanceDate = appStore.workflowStore.timelineWorkflowStore.contractAcceptanceDate;

        const transition = new WorkflowStepTransitionModel();
        transition.status = Cons.transitionTypes.Active;
        transition.createdOn = moment().format();
        transition.reasons.push('Step completed');
        step.state.transitions.push(transition);

        const createReminders = () => {
            return this.createRemindersInGoogle()
                .then(({ reminderData, eventErrors }) => {
                    appStore.workflowStore.setLoading(false);
                    step.state.data.reminderData = reminderData;
                    step.state.data.errors = eventErrors;
                    this.updateStepState(step);
                })
                .catch(err => {
                    appStore.workflowStore.setLoading(false);
                    Rollbar.error('Failed to create Google Reminders', err);
                    Notfication.ToastError('Failed to create Google Reminders');
                    this.updateStepState(step);
                });
        };
        if (step.state.data.reminderData && step.state.data.reminderData.length > 0) {
            this.deleteRemindersInGoogle().then(() => {
                createReminders();
            });
        } else {
            createReminders();
        }
    }

    @action
    handleCancel() {
        const step = this.props.step;
        step.state.isComplete = true;
        this.updateStepState(step);
    }

    @action
    handleAddLineItem() {}

    deleteRemindersInGoogle() {
        const model = this.props.step.state.data,
            reminderData = model.reminderData && model.reminderData.length > 0 ? model.reminderData : null;

        if (!reminderData) {
            console.log("Shouldn't have got here. Reminder data not found.");
            return;
        }
        const deleteCalendarEventPromises = [],
            eventErrors = [];
        _.each(reminderData, reminder => {
            const promise = this.googleAPIResource
                .deleteCalendarEvent(this.props.appStore.authStore.getAccessToken(), reminder.eventId)
                .catch(() => {
                    eventErrors.push(reminder);
                });
            deleteCalendarEventPromises.push(promise);
        });
        return new Promise(resolve => {
            Promise.all(deleteCalendarEventPromises)
                .then(() => {
                    model.errors = eventErrors || [];
                    if (model.errors.length <= 0) {
                        resolve();
                    } else {
                        Notfication.ToastError('Some events were not deleted. ');
                        resolve();
                    }
                })
                .catch(err => {
                    console.log(err);
                    resolve();
                });
        });
    }

    getConstantStepsTimeline(timelineStepState) {
        const constantSteps = this.props.appStore.workflowStore.constantAuditWorkflowSteps;

        const timeline = constantSteps.map(step => {
            const deadlineCalculated = DeadlineCalculatedHelper.getDeadlineCalculated(step, timelineStepState);
            return {
                deadlineCalculated,
                name: step.title,
                reminders: step.reminders,
                recurrences: step.recurrences,
                timelineEventId: step.stepId,
                excludeFromCalendarReminders:step.excludeFromCalendarReminders,
            };
        });

        return timeline;
    }

    createRemindersInGoogle() {
        const model = this.props.step.state.data,
            calendarStepsTimeline = _.filter(model.timeline, x => {
                return x.exclude === false && !x.excludeFromCalendarReminders;
            }),
            selectedFile = this.props.appStore.tcFileStore.selectedFile,
            eventErrors = [],
            reminderData = [],
            constantStepsTimeline = this.getConstantStepsTimeline(this.props.step.state).filter(x=>{return !x.excludeFromCalendarReminders}),
            timeline = calendarStepsTimeline.concat(constantStepsTimeline);

        const googleCreateCalendarEventPromises = timeline.map(timelineEvent => {
            const eventName = timelineEvent.name,
                startTime = moment(timelineEvent.deadlineCalculated).set({
                    hour: '5',
                    minute: 0,
                    second: 0,
                    millisecond: 0,
                }),
                property = this.props.appStore.tcFileStore.selectedFile.propertyAddress,
                calendarEvent = {
                    start: { 
                        dateTime: startTime.format("YYYY-MM-DDThh:mm:ss"), 
                        timeZone: 'America/Los_Angeles' 
                    },
                    end: { 
                        dateTime: startTime.format("YYYY-MM-DDThh:mm:ss"),
                        timeZone:'America/Los_Angeles'
                    },
                    summary: property + ' - ' + timelineEvent.name,
                    recurrence: timelineEvent.recurrences || [],
                    description: `File Link:${window.location.origin}/#/filedetail/${selectedFile.tcFileId} \r\n Agent: ${selectedFile.agent.name}`,
                    reminders: {
                        overrides: timelineEvent.reminders.map(reminderDays => {
                            return {
                                method: 'email',
                                minutes: reminderDays * 1440,
                            };
                        }),
                        useDefault: false,
                    },
                    externalId: this.props.appStore.tcFileStore.selectedFile.tcFileId,
                };

            return this.googleAPIResource
                .createCalendarEvent(this.props.appStore.authStore.getAccessToken(), calendarEvent)
                .then(result => {
                    reminderData.push({ timelineEventId: timelineEvent.timelineEventId, eventId: result.id });
                })
                .catch(() => {
                    eventErrors.push(eventName);
                });
        });
        return new Promise(resolve => {
            Promise.all(googleCreateCalendarEventPromises)
                .then(() => {
                    model.errors = eventErrors || [];
                    if (model.errors.length <= 0) {
                        resolve(reminderData);
                    } else {
                        Notfication.ToastError('Some events were not created. ');
                        resolve(reminderData);
                    }
                })
                .catch(err => {
                    console.log(err);
                    resolve(reminderData);
                });
        });
    }

    batchCreateRemindersInGoogle() {
        const model = this.props.step.state.data,
            calendarStepsTimeline = _.filter(model.timeline, x => {
                return x.exclude === false && !x.excludeFromCalendarReminders;
            }),
            selectedFile = this.props.appStore.tcFileStore.selectedFile,
            constantStepsTimeline = this.getConstantStepsTimeline(this.props.step.state),
            timeline = calendarStepsTimeline.concat(constantStepsTimeline);

        const calendarEvents = timeline.map(timelineEvent => {
            const eventName = timelineEvent.name,
                startTime = moment(timelineEvent.deadlineCalculated).set({
                    hour: '5',
                    minute: 0,
                    second: 0,
                    millisecond: 0,
                }),
                calendarEvent = {
                    start: { dateTime: startTime.format() },
                    end: { dateTime: startTime.format() },
                    summary: this.props.appStore.tcFileStore.selectedFile.propertyAddress + ' - ' + timelineEvent.name,
                    description: `File Link:${window.location.origin}/#/filedetail/${selectedFile.tcFileId} \r\n Agent: ${selectedFile.agent.name}`,
                    reminders: {
                        overrides: timelineEvent.reminders.map(reminderDays => {
                            return {
                                method: 'email',
                                minutes: reminderDays * 1440,
                            };
                        }),
                        useDefault: false,
                    },
                    eventName: eventName,
                    externalId: this.props.appStore.tcFileStore.selectedFile.tcFileId,
                };
            return calendarEvent;
        });

        return this.googleAPIResource
            .batchCreateCalendarEvents(this.props.appStore.authStore.getAccessToken(), calendarEvents)
            .then(eventResponses => {
                const eventErrors = [],
                    reminderData = [];
                eventResponses.forEach(response => {
                    if (response.statusCode !== '200') {
                        eventErrors.push(response.eventName);
                    } else {
                        reminderData.push({ eventId: response.id });
                    }
                });
                return { reminderData, eventErrors };
            });
    }

    batchDeleteRemindersInGoogle() {
        const model = this.props.step.state.data,
            reminderData = model.reminderData;
        const googleEventIds = [];
        _.each(reminderData, reminder => {
            googleEventIds.push({ eventId: reminder.eventId });
        });

        return this.googleAPIResource
            .batchDeleteCalendarEvents(this.props.appStore.authStore.getAccessToken(), googleEventIds)
            .then(eventResponses => {
                const eventErrors = [];
                eventResponses.forEach(response => {
                    // if (response.statusCode !== '204') {
                    //     // eventErrors.push(response.eventName)
                    // }
                });
                return {};
            });
    }

    renderCompleteEventInstances(eventInstances) {
        return _.filter(eventInstances, eventInstance => {
            return !eventInstance.excludeFromEmailGrid;
        }).map(eventInstance => {
            return (
                <tr key={eventInstance.timelineeventid}>
                    <td>{eventInstance.name}</td>
                    <td className="dates">
                        <div>
                            {TimelineRenderHelper.formatTimelineInstanceDate(
                                eventInstance.deadlineCalculated,
                                eventInstance.exclude
                            )}
                        </div>
                        <div>
                            {TimelineRenderHelper.formatTimelineInstanceDateShift(
                                eventInstance.weekendDateShift,
                                eventInstance.holidayDateShift,
                                eventInstance.exclude
                            )}
                        </div>
                    </td>
                </tr>
            );
        });
    }

    @action
    handleReset() {
        const calenderStep = _.find(appStore.workflowStore.workflow, {
            stepId: '572ace14-fb4a-4fdb-8acc-c9f4c3260c45',
        });
        const step = this.props.step;
        step.state.isComplete = false;
        step.state.data.contractAcceptanceDate = appStore.workflowStore.timelineWorkflowStore.contractAcceptanceDate;
        this.updateStepState(step);
    }

    renderCompleteView(step) {
        const model = step.state.data,
            errors = model.errors || [];
        return (
            <div className="workflow-timeline-step">
                <Row>
                    <Col xs={12}>{model.message}</Col>
                </Row>
                <br />
                <Row>
                    <Col xs={12} className="timeline-title">
                        Transaction Timeline
                    </Col>
                </Row>
                <Row>
                    <Col xs={9}>
                        <Table responsive className="timeline-table">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th className="dates">Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Contract Accepted</td>
                                    <td className="dates">
                                        <div>
                                            {!_.isEmpty(model.contractAcceptanceDate)
                                                ? TimelineRenderHelper.formatTimelineInstanceDate(
                                                      model.contractAcceptanceDate,
                                                      false
                                                  )
                                                : ''}
                                        </div>
                                    </td>
                                </tr>
                                {this.renderCompleteEventInstances(model.timeline)}
                            </tbody>
                        </Table>
                    </Col>
                    <Col xs={12}>
                        <a
                            href={`https://calendar.google.com/calendar/r/search?q=${encodeURIComponent(
                                this.props.appStore.tcFileStore.selectedFile.propertyAddress
                            )}`}
                            target="_blank"
                        >
                            Review events
                        </a>
                    </Col>
                    {errors.map((error, i) => {
                        return (
                            <Col key={`timelineEventError-${i}`} xs={12}>
                                <span>
                                    Failed to create event: <b>{error}</b>
                                </span>
                            </Col>
                        );
                    })}
                </Row>
                <Button onClick={this.handleReset.bind(this)} className="pull-right" bsStyle="primary">
                    Edit
                </Button>
                <div className={'col-md-12'}>
                    <StepHistory
                        transitions={this.props.step.state.transitions ? this.props.step.state.transitions : []}
                        emails={this.props.step.state.data.emails ? this.props.step.state.data.emails : []}
                    />
                </div>
            </div>
        );
    }

    createTasksButtonEnabled() {
        return (
            appStore.workflowStore.timelineWorkflowStore.contractAcceptanceDate &&
            _.every(appStore.workflowStore.timelineWorkflowStore.timelineEventInstancesCalculated, x => {
                return ((x.days || x.days === 0) && _.trim(x.name)) || x.exclude;
            })
        );
    }

    handleLineItemAdd() {
        appStore.workflowStore.timelineWorkflowStore.addTimelineEvent();
    }

    handleContractAcceptanceDateChanged(selectedDate) {
        appStore.workflowStore.timelineWorkflowStore.setContractAcceptanceDate(selectedDate);
        setTimeout(() => {
            //Yes, I really did use jQuery.
            $('#contractAcceptanceDatePicker').blur();
        });
    }

    renderIncompleteView(step) {
        const hasReminderData = !!this.props.step.state.data.reminderData,
            hasTimelineData = !!this.props.step.state.data.timeline;

        return (
            <div className="workflow-timeline-step">
                <Row>
                    <div className="col-sm-6">
                        <StepActionButtons hideNaAction viewStore={this.viewStore} step={this.props.step} />
                    </div>
                </Row>
                <hr className="section-header" />
                <Row>
                    <FormGroup controlId="timelineForm">
                        <Col sm={3}>
                            <ControlLabel>Contract Acceptance</ControlLabel>
                        </Col>
                        <Col sm={9}>
                            <DatePicker
                                fixedHeight                                
                                id="contractAcceptanceDatePicker"
                                className="form-control input-sm"
                                onChange={selectedDate => {
                                    this.handleContractAcceptanceDateChanged(selectedDate);
                                }}
                                selected={appStore.workflowStore.timelineWorkflowStore.contractAcceptanceDate}                                
                            ></DatePicker>
                        </Col>
                    </FormGroup>
                </Row>
                <Row>
                    <Col xs={12} className="timeline-edit">
                        <Row>
                            <Col xs={4} tabIndex={1} ref={c => (this.eventRef = c)}>
                                <b>Event</b>
                            </Col>
                            <Col xs={1}>
                                <b>Days</b>
                            </Col>
                            <Col xs={3}>
                                <b>Deadline (Calculated)</b>
                            </Col>
                            <Col xs={3}>
                                <Row>
                                    <Col xs={3} style={{ display: 'flex', justifyContent: 'center' }}>
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={<Tooltip id="tooltip">Remove from workflow</Tooltip>}
                                        >
                                            <span className={`fa-stack`}>
                                                <i className={`fa fa-list fa-stack-2x`} />
                                            </span>
                                        </OverlayTrigger>
                                    </Col>
                                    <Col xs={3} style={{ display: 'flex', justifyContent: 'center' }}>
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={<Tooltip id="tooltip">Do not create calendar reminders</Tooltip>}
                                        >
                                            <span className={`fa-stack`}>
                                                <i className={`fa fa-calendar fa-stack-2x `} />
                                            </span>
                                        </OverlayTrigger>
                                    </Col>
                                    <Col xs={3} style={{ display: 'flex', justifyContent: 'center' }}>
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={<Tooltip id="tooltip">Remove row in email</Tooltip>}
                                        >
                                            <span className={`fa-stack`}>
                                                <i className={`fa fa-envelope-o fa-stack-2x`} />
                                            </span>
                                        </OverlayTrigger>
                                    </Col>
                                    <Col
                                        xs={3}
                                        className={'na-label'}
                                        style={{ display: 'flex', justifyContent: 'center' }}
                                    >
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={<Tooltip id="tooltip">Display N/A in email</Tooltip>}
                                        >
                                            <div>N/A in email</div>
                                        </OverlayTrigger>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={1}>
                                <b></b>
                            </Col>
                        </Row>

                        <div>
                            <DndContainer
                                items={appStore.workflowStore.timelineWorkflowStore.timelineEventInstancesCalculated}
                                itemStore={appStore.workflowStore.timelineWorkflowStore}
                                setDays={appStore.workflowStore.timelineWorkflowStore.setDays.bind(
                                    appStore.workflowStore.timelineWorkflowStore
                                )}
                                setExclude={appStore.workflowStore.timelineWorkflowStore.setExclude.bind(
                                    appStore.workflowStore.timelineWorkflowStore
                                )}
                                setExcludeFromWorkflow={appStore.workflowStore.timelineWorkflowStore.setExcludeFromWorkflow.bind(
                                    appStore.workflowStore.timelineWorkflowStore
                                )}
                                setExcludeFromEmailGrid={appStore.workflowStore.timelineWorkflowStore.setExcludeFromEmailGrid.bind(
                                    appStore.workflowStore.timelineWorkflowStore
                                )}
                                setExcludeFromCalendarReminders={appStore.workflowStore.timelineWorkflowStore.setExcludeFromCalendarReminders.bind(
                                    appStore.workflowStore.timelineWorkflowStore
                                )}
                                setName={appStore.workflowStore.timelineWorkflowStore.setName.bind(
                                    appStore.workflowStore.timelineWorkflowStore
                                )}
                            />
                        </div>
                        <Row>
                            <Col xs={12}>
                                <Button bsStyle="primary" onClick={this.handleLineItemAdd.bind(this)}>
                                    <span className={`fa fa-plus`} />
                                </Button>
                            </Col>
                            {!hasReminderData && hasTimelineData ? (
                                <Col xs={12}>
                                    <h5>Go to Google Calendar and delete old reminders before you click Confirm.</h5>
                                </Col>
                            ) : null}
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <Button
                            className="pull-right"
                            disabled={!this.createTasksButtonEnabled()}
                            bsStyle="primary"
                            onClick={this.handleSend.bind(this)}
                        >
                            Confirm
                        </Button>
                        <Button
                            className="pull-right"
                            disabled={!this.props.step.state.data.timeline}
                            bsStyle="default"
                            style={{ marginRight: 10 }}
                            onClick={this.handleCancel.bind(this)}
                        >
                            Cancel
                        </Button>
                    </Col>
                </Row>

                <div className={'col-md-12'}>
                    <StepHistory
                        transitions={this.props.step.state.transitions ? this.props.step.state.transitions : []}
                        emails={this.props.step.state.data.emails ? this.props.step.state.data.emails : []}
                    />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/workflow/steps/timeline/timeline-workflow-step.js